import { useFormContext, useWatch } from "react-hook-form"
import { genderOptions } from "~/common/enums"
import { Checkbox } from "~/shadcn/ui/checkbox"
import { FormField, FormItem, FormMessage } from "~/shadcn/ui/form"
import { SearchSubLabel } from "./SearchSubLabel"
import { SearchValues } from "../../schema"
import { GenderEnum } from "~/__generated__/graphql"

const FIELD_NAME = "genders"

export const GenderFilter = () => {
  const form = useFormContext<SearchValues>()

  const selectedGenders =
    useWatch({
      control: form.control,
      name: FIELD_NAME,
    }) || []

  const toggleGender = (gender: GenderEnum) => {
    if (selectedGenders.includes(gender)) {
      form.setValue(
        FIELD_NAME,
        selectedGenders.filter((c) => c !== gender)
      )
    } else {
      form.setValue(FIELD_NAME, [...selectedGenders, gender])
    }
  }

  return (
    <FormField
      control={form.control}
      name={FIELD_NAME}
      render={() => (
        <FormItem className="flex-1">
          <SearchSubLabel text="Influencer" />
          <div className="grid grid-cols-2 gap-2">
            {genderOptions.map((option) => (
              <GenderOption
                key={option.value}
                label={option.label}
                value={option.value}
                selected={selectedGenders.includes(option.value)}
                onClick={() => toggleGender(option.value)}
              />
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

const GenderOption = ({
  label,
  value,
  selected,
  onClick,
}: {
  label: string
  value: GenderEnum
  selected: boolean
  onClick: () => void
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={`gender-${value}`}
        checked={selected}
        onCheckedChange={onClick}
      />
      <label
        htmlFor={`gender-${value}`}
        className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {label}
      </label>
    </div>
  )
}
